import { createAction, props } from '@ngrx/store';
import { PartnerResponseCommercial } from 'src/app/pages/orders/interfaces/partnerCommercial.interface';

export const getCalendarsPartner = createAction(
  '[CalendarsPartner] Get',
  props<{
    key: string;
    params: { countryCode: string; salesOrgCode: string; partnerCodes: string; cutOffTime: boolean };
  }>(),
);

export const getCalendarsPartnerSuccess = createAction(
  '[CalendarsPartner] Get Success',
  props<{ key: string; response: PartnerResponseCommercial }>(),
);

export const getCalendarsPartnerFailure = createAction(
  '[CalendarsPartner] Get Failure',
  props<{ key: string; error: any }>(),
);

export const setCalendarsPartnerEmptyCache = createAction(
  '[CalendarsPartner] Set Empty Cache',
  props<{ key: string; response: unknown[] }>(),
);

export const resetCalendarsPartner = createAction('[CalendarsPartner] Reset');
